export default __webpack_public_path__ + "static/media/bulls2_transp.cbfa9831.png";